import { IMeasureType, IMetricBatchEvaluationResult, IMetricEvaluateRequest } from "@src/types/ab-testing-exploration";
import { useBaseEvaluateMetric } from "./use-base-evaluate";

export type AbExplorationEvaluateMetricProps = {
    baseGroup: string;
    variantGroups: string[];
    metric?: string;
    metricType?: IMeasureType;
    significanceLevel: number;
    data: any;
    refineOptions?: {
        dataProviderName?: string;
    };
    batch?: boolean;
    isSkip?: boolean;
};

export const useAbExplorationEvaluateMetric = ({
    baseGroup,
    variantGroups,
    metric,
    metricType,
    significanceLevel,
    data,
    refineOptions,
    batch = false,
    isSkip = false,
}: AbExplorationEvaluateMetricProps) => {
    const requestPayload: IMetricEvaluateRequest = {
        base_group: baseGroup,
        variant_groups: variantGroups,
        metric: metric ?? "",
        significance_level: significanceLevel,
        data,
    };

    const apiEndPoint = batch ? "/batch" : "";
    const { httpError, isLoading, refetch, result } = useBaseEvaluateMetric<IMetricBatchEvaluationResult>({
        metricType,
        requestPayload,
        apiEndPoint,
        isSkip,
        refineOptions,
    });

    return {
        isLoading,
        result,
        httpError,
        refetch,
    };
};
